<mat-nav-list [ngClass]="{'menu-hide':!isExpand && forRestrictView}">
    <div id="hamburger_menu" class="app-title cursor" (click)="onChangeSideNav()">
        <!-- <mat-icon >menu_open</mat-icon> -->
        <img  *ngIf="isExpand" src="assets/img/AU-img/hamburger_menu.svg" />
        <img *ngIf="!isExpand" src="assets/img/AU-img/hamburger_menu_back.svg" />
    </div>
    <div>
        <mat-list *ngFor="let item of menuItems">
            <mat-list-item id="{{item.name}}" [routerLinkActive]="['active']" routerLink="{{item.link}}">
                <mat-icon [svgIcon]="item.icon" *ngIf="item.source == 'custom'"></mat-icon>
                <mat-icon *ngIf="item.source == 'mat'">{{item.icon}}</mat-icon> 
                <span class="list-item-text" *ngIf="isExpand">{{translate.instant(item.name)}}</span>
            </mat-list-item>
        </mat-list>
    </div>
</mat-nav-list>